// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"PJ-z","carouselContainer":"QJ-z"};